import * as m from 'mithril';
import CustomSvgIcon from '../../components/CustomSvgIcon';
import { WayPointOptionDTO } from '../../apiclient/ApiDtos';
import { formatMoney } from '../../helpers/MoneyFormatter';
import { MessageProvider } from '../../context/AppMessages';

interface Attrs {
    mode: 'PICKUP' | 'DROPOFF',
    messageProvider: MessageProvider,
    wayPointOptions: WayPointOptionDTO[],
    onWayPointSelected: (wayPoint: WayPointOptionDTO) => void
}

//const notMyanmarSyllablesRegex = /[^\u1000-\u1021]/g;
const anyMyanmarCharacterRegex = /[\u1000-\u103F]/;
const anyMyanamrTonalDecoRegex = /[\u1036-\u1038]/g;

function WayPointFilterList(): m.Component<Attrs> {
    let pickUpOrDropOffOptions: WayPointOptionDTO[] = [];


    return {
        oncreate(vnode) {
            let elem = document.getElementById("location-filter-input");
            if (elem != null) {
                elem.focus();
            }
        },

        view(vnode) {
            pickUpOrDropOffOptions = vnode.attrs.wayPointOptions;

            let pickupPoints = pickUpOrDropOffOptions.slice(0)
                .filter(point => (point.mode == 'DOORSTEP'));

            let gatheringPoints = pickUpOrDropOffOptions.slice(0)
                .filter(point => (point.mode == 'FIXED_POINT'));

            return m("div.p-2", [
                m("div", { class: "form-group" }, [
                    /*  m("div", {
                             class:"bg-white p-3 sticky-top shadow-sm"
                         },                    
                         m("input", {
                             id:"location-filter-input",
                             type:"text",
                             class: "form-control",
                             placeholder:"Search...",
                             autocomplete:"off",
                             oninput : function(event) {
                                 //updateFilterText(event.target.value);
                             }
                         }),
                     ), */

                    (gatheringPoints.length > 0) &&
                    [
                        m("div.mt-2 mb-2 pl-2 font-weight-bold text-secondary",
                            //vnode.attrs.mode == 'PICKUP'?
                            vnode.attrs.messageProvider.get("common.gathering_points")
                        ),
                        m("div.mb-4", { class: "list-group list-group-flush px-0" }, [

                            gatheringPoints.map(function (pickUpOrDropOffOption) {
                                return m("a", {
                                    class: "list-group-item list-group-item-action text-my",
                                    href: "#",
                                    onclick: function (event) {
                                        event.preventDefault();
                                        vnode.attrs.onWayPointSelected(pickUpOrDropOffOption);
                                    }
                                }, [
                                    m("div.row", [
                                        m("div", { class: "col-11" },
                                            (vnode.attrs.messageProvider.getCurrentLang() == 'en') ?
                                                [m("span.mr-1", {}, pickUpOrDropOffOption.name.en), m("small.text-muted", {}, " (" + pickUpOrDropOffOption.name.my + ")")] :
                                                [m("span.mr-1", {}, pickUpOrDropOffOption.name.my), m("small.text-muted", {}, " (" + pickUpOrDropOffOption.name.en + ")")]
                                        ),
                                        m("div", { class: "col-1 text-right" },
                                            m(CustomSvgIcon, {
                                                iconType: 'keyboard_arrow_right',
                                                themeCssClass: "svg-small svg-muted stroke-muted"
                                            })
                                        )
                                    ]),

                                    (pickUpOrDropOffOption.pricingMode ?? 'PER_SEAT') == 'PER_STOP' ?
                                        m("div.row mt-1",
                                            m("div.col.text-success", formatMoney(pickUpOrDropOffOption.unitFee))
                                        )
                                        :
                                        m("div.row mt-1",
                                            m("div.col-12 small text-muted",
                                                vnode.attrs.messageProvider.get("way_point_selection.one_person"), " ▹ ",
                                                m("span.text-success", formatMoney(pickUpOrDropOffOption.unitFee))
                                            )
                                        )
                                ])
                            }),
                        ]),
                    ],

                    (pickupPoints.length > 0) &&
                    [
                        m("div.mb-2 mt-3 pl-2 font-weight-bold text-secondary",

                            vnode.attrs.mode == 'PICKUP' ?
                                vnode.attrs.messageProvider.get("common.home_address_pickup_locations")
                                :
                                vnode.attrs.messageProvider.get("common.home_address_dropoff_locations")
                        ),
                        m("div", { class: "list-group list-group-flush px-0" }, [
                            pickupPoints.map(function (pickUpOrDropOffOption) {
                                return m("a", {
                                    class: "list-group-item list-group-item-action text-my",
                                    href: "#",
                                    onclick: function (event) {
                                        event.preventDefault();
                                        vnode.attrs.onWayPointSelected(pickUpOrDropOffOption);
                                    }
                                }, [
                                    m("div.row", [
                                        m("div", { class: "col-11" },
                                            (vnode.attrs.messageProvider.getCurrentLang() == 'en') ?
                                                [m("span.mr-1", {}, pickUpOrDropOffOption.name.en), m("small.text-muted", {}, " (" + pickUpOrDropOffOption.name.my + ")")] :
                                                [m("span.mr-1", {}, pickUpOrDropOffOption.name.my), m("small.text-muted", {}, " (" + pickUpOrDropOffOption.name.en + ")")]
                                        ),
                                        m("div", { class: "col-1 text-right" },
                                            m(CustomSvgIcon, {
                                                iconType: 'keyboard_arrow_right',
                                                themeCssClass: "svg-small svg-muted stroke-muted"
                                            })
                                        )
                                    ]),

                                    (pickUpOrDropOffOption.pricingMode ?? 'PER_SEAT') == 'PER_STOP' ?
                                        m("div.row mt-1",
                                            m("div.col.text-success", formatMoney(pickUpOrDropOffOption.unitFee))
                                        )
                                        :
                                        m("div.row mt-1",
                                            m("div.col-12 small text-muted",
                                                vnode.attrs.messageProvider.get("way_point_selection.one_person"), " ▹ ",
                                                m("span.text-success", formatMoney(pickUpOrDropOffOption.unitFee))
                                            )
                                        )
                                ])
                            }),
                        ]),
                        (pickUpOrDropOffOptions.length == 0) ?
                            m("div.list-group-item list-group-item-action", [
                                m("div.m-1",
                                    m("div", `No result found.`)
                                )
                            ]) : null
                    ]
                ]
                )
            ])
        }
    }
}


export default WayPointFilterList;
